(() => {
    window.Dashboard = window.Dashboard || {};

    window.Dashboard.Models = window.Dashboard.Models || {};

    /**
     * The Role Context used to check if the user has permissions
     * @constructor
     */
    class Subscription {
        /**
         * The Id of the subscription
         * @type {number}
         */
        Id = undefined;

        /**
         * The Template Id used by the subscription
         * @type {number}
         */
        TemplateId = undefined;

        /**
         * The TemplateHTML for the Template Id for the subscription
         * @type {string}
         */
        TemplateHTML = undefined;

        /**
         * Initialises the subscription with the subscription returned from the API
         */
        initialiseSubscription = function (subscription) {
            return _.extend(this, subscription);
        };
    }
    window.Dashboard.Models.Subscription = Subscription;
})();
